import { css } from "@emotion/react";
import { FC } from "react";

import BackLink from "~/components/item/[id]/BackLink";
import ResponseContent from "~/components/item/[id]/response-content";
import { Props } from "~/components/item/page/[id]/lib";

const PcPage: FC<Props> = ({ response }) => {
  return (
    <main>
      <ResponseContent
        questions={response.form.questions}
        response={response}
      />
      <div css={backLinkContainerStyle}>
        <BackLink form={response.form} />
      </div>
    </main>
  );
};

const backLinkContainerStyle = css`
  margin-top: 5rem;
  margin-left: 5rem;
`;

export default PcPage;
